"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Switch_1 = require("@material-ui/core/Switch");
var currencySwitchStyles_1 = require("./currencySwitchStyles");
var Box_1 = require("@material-ui/core/Box");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var ToggleSwitch = function (_a) {
    var onChange = _a.onChange, disableRipple = _a.disableRipple, labelBefore = _a.labelBefore, labelAfter = _a.labelAfter, props = __rest(_a, ["onChange", "disableRipple", "labelBefore", "labelAfter"]);
    var styles = currencySwitchStyles_1.default(props);
    return (<>
      <Grid_1.default container={true} alignItems="center" spacing={1} className={styles.switchContainer}>
        <Typography_1.default component="p" className={styles.selectCurrency}>
          <Translation_1.default id={'trans__checkout__vehicle_details__select_currency'}/>
        </Typography_1.default>
        <Typography_1.default component="p" className={props.checked ? styles.unselectedCurrency : styles.selectedCurrency}>
          {labelBefore}
        </Typography_1.default>
        <Box_1.default>
          <Switch_1.default {...props} onChange={onChange} focusVisibleClassName={styles.focusVisible} disableRipple={disableRipple} classes={{
        root: styles.root,
        switchBase: styles.switchBase,
        thumb: styles.thumb,
        track: styles.track,
        checked: styles.checked,
    }}/>
        </Box_1.default>
        <Typography_1.default component="p" className={props.checked ? styles.selectedCurrency : styles.unselectedCurrency}>
          {labelAfter}
        </Typography_1.default>
      </Grid_1.default>
    </>);
};
exports.default = ToggleSwitch;
